import { render, staticRenderFns } from "./AlbumLibrary.vue?vue&type=template&id=a289e3e6&scoped=true"
import script from "./AlbumLibrary.vue?vue&type=script&lang=js"
export * from "./AlbumLibrary.vue?vue&type=script&lang=js"
import style0 from "./AlbumLibrary.vue?vue&type=style&index=0&id=a289e3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a289e3e6",
  null
  
)

export default component.exports